import Box from '@mui/system/Box';
import React, { useEffect, useState } from 'react';
import { handleUnauthorizedResponse } from '../../../api/http';
import InvoiceApi from '../../../api/InvoiceApi';
import { AuthData } from '../../../context/auth';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import { HEADER_HEIGHT } from '../../../data/constants';
import { FETCH_INVOICES_FAILURE } from '../../../data/labelsAndMessages';
import { PolicyInvoice2Response } from '../../../types/policy';
import LargeCenterSpinner from '../../LargeCenterSpinner';
import NewInvoicesTable from '../../NewInvoicesTable';
import { errorToast } from '../../Toast';

interface Props {
	authData: AuthData;
	cancellationData: CancellationData;
	invoiceLocator: string;
}

const InvoicesView = (props: Props) => {
	const { cancellationData, authData, invoiceLocator } = props;
	const { selectedCancellation } = cancellationData;

	const [loading, setLoading] = useState(false);
	const [invoice, setInvoice] = useState<PolicyInvoice2Response>(null);

	useEffect(() => {
		const load = async () => {
			try {
				// only set loading if no invoice set yet
				if (!invoice) {
					setLoading(true);
				}
				const invoiceResponse = await InvoiceApi.fetchInvoice(
					authData.auth.authorizationToken,
					invoiceLocator,
				);
				setInvoice(invoiceResponse.data);
				setLoading(false);
			} catch (error) {
				setLoading(true);
				if (await handleUnauthorizedResponse(error, authData)) {
					return;
				}
				errorToast(FETCH_INVOICES_FAILURE());
			}
		};

		if (invoiceLocator) {
			load();
		}
	}, [invoiceLocator, selectedCancellation]);

	if (loading) {
		return <LargeCenterSpinner />;
	}

	return (
		<Box
			sx={{
				pt: 4,
				pb: 4,
				backgroundColor: 'background.default',
				height: `calc(100vh - ${HEADER_HEIGHT}px)`,
			}}
		>
			<NewInvoicesTable
				invoices={invoice ? [invoice] : []}
				policyholderLocator={cancellationData?.policy?.policyholderLocator}
				currency={
					cancellationData && cancellationData.policy
						? cancellationData.policy.currency
						: null
				}
			/>
		</Box>
	);
};

export default withCancellationContext<Props>(InvoicesView);
